// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cYY1","buttons":"styles_buttons__DeU_v"};